import React, { useCallback, useState } from 'react';

import { UnverifiedCompanyType } from '../../../../common/constants';
import { useUnverifiedCompanyRestrictionModal } from '../../../../common/hooks/useUnverifiedCompanyRestrictionModal/useUnverifiedCompanyRestrictionModal';
import { loadable } from '../../../../common/loadable';
import { TopUpGlintsCreditModalProps } from '../TopUpGlintsCreditModal';

const TopUpGlintsCreditModal = loadable<TopUpGlintsCreditModalProps>(
  () => import('../TopUpGlintsCreditModal').then(module => module.default),
  { fallback: undefined }
);

export default function useTopUpGlintsCreditModal() {
  const [shouldRenderModal, setShouldRenderModal] = useState(false);

  const closeModal = useCallback(() => {
    setShouldRenderModal(false);
  }, []);

  const { getOpenRestrictionModalFunc } = useUnverifiedCompanyRestrictionModal({
    type: UnverifiedCompanyType.FEATURE_PURCHASE,
  });
  const openRestrictionModalFunc = getOpenRestrictionModalFunc();

  const openModal = useCallback(() => {
    if (openRestrictionModalFunc) {
      return openRestrictionModalFunc();
    }
    if (!shouldRenderModal) {
      setShouldRenderModal(true);
    }
  }, [shouldRenderModal, openRestrictionModalFunc]);

  return {
    // eslint-disable-next-line jsx-control-statements/jsx-use-if-tag
    TopUpGlintsCreditModal: shouldRenderModal ? (
      <TopUpGlintsCreditModal onClose={closeModal} />
    ) : null,
    openModal,
  };
}
